import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class LinkedinPromotionService {
  createDeal(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "linkedin/promotion/deal/create", body);
  }

  updateDeal(id, body) {
    return httpRequestAdmin.put(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/update/${id}`, body);
  }

  getDealByCompanyId(companyId) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/${companyId}`);
  }

  getTotalStats() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/total-stats`);
  }

  deleteDeal(id) {
    return httpRequestAdmin.delete(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/delete/${id}`);
  }

  recoverDeal(companyId) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/recover/${companyId}`);
  }

  manualAdjustDeal(companyId, body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/manual-adjust/${companyId}`, body);
  }
}

export default new LinkedinPromotionService();
